<template>
    <div>
        <el-row :gutter="30" class="searchSection">
            <el-col :span="6">
                <div>
                    <label class="item-title">试用效率分析</label>
                    <el-tooltip placement="right">
                    <div slot="content">
                        试用效率：（有效试用客户数/试用客户数）*100%<br />
                        有效试用客户：指开通试用订单，并有下载资料的客户<br />
                        试用客户(资源)：开通组卷、校网通、校本3及校本资源库试用订单的客户<br />
                    </div>
                    <i class="el-icon-info"></i>
                    </el-tooltip>
                </div>
                <div>
                    <label class="item-desc">按录单时间统计二一组卷、二一校网通、校本3及校本资源库试用</label>
                </div>
            </el-col>
            <el-col :span="18">
                <el-form ref="form" :inline="true" :model="searcheModel">
                    <el-form-item label="下载不少于:">
                        <el-input type="number" size="mini" v-model="searcheModel.down_num" style="width:80px;"></el-input>
                    </el-form-item>
                    <el-form-item label="科目不少于:">
                        <el-input type="number" size="mini" v-model="searcheModel.subject_num" style="width:80px;"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="mini" @click="getList">确定</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <div style="height: 280px; overflow-y: auto">
            <el-table :data="list" style="width: 100%" v-loading="loading">
                <el-table-column prop="name" width="250"></el-table-column>
                <el-table-column>
                    <template slot-scope="scope">
                        <span><el-progress status="success" :text-inside="true" :percentage="scope.row.deep_trial_ratio ? (scope.row.deep_trial_ratio > 100 ? 100 : (scope.row.deep_trial_ratio < 0 ? 0 : scope.row.deep_trial_ratio)) : 0" :stroke-width="26" :key="scope.row.id"></el-progress></span>
                    </template>
                </el-table-column>
                <el-table-column prop="finish_amount" width="150">
                    <template slot-scope="scope">
                        <span>{{ scope.row.deep_trial_customer_num }} / {{ scope.row.try_out_customer_num }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-row :gutter="10">
            <el-col :span="8">
                <label class="item-title">有效试用客户：</label>
                <span class="grid-count-num">{{total_deep_trial_num}}</span>
            </el-col>
            <el-col :span="8">
                <label class="item-title">试用客户(资源)：</label>
                <span class="grid-count-num">{{total_try_out_num}}</span>
            </el-col>
        </el-row>
    </div>
</template>
<style scoped>
.item-title {
  font-size: 14px;
  font-weight: bolder;
}
.item-desc {
  font-size: 10px;
  color: #aaaaaa;
}
.grid-count-num {
  font-size: 16px;
  color: red;
}
</style>
<script>
import OrderCount from "~/services/OrderCount";

export default {
    name: "customerRatioProgress",
    props:{
        params:{
            type: Object,
            required: true,
        },
        table_height:{
            type: String,
            default: '600px',
        }
    },
    data() {
        return {
            loading: false,
            list: [],
            searcheModel: {
                down_num: '50',
                subject_num: '2',
            },
            total_try_out_num: 0,
            total_deep_trial_num: 0,
        };
    },
    created(){
        this.getList();
    },
    mounted() {
        
    },
    methods: {
        getList() {
            this.loading = true;
            // let params = _.clone(this.params);
            const params = Object.assign({}, this.params, this.searcheModel);
            OrderCount.getCustomerRatio(params).then((res) => {
                if (res.code == 0 && res.data && res.data.length > 0) {
                    this.list = res.data;
                    // 计算 try_out_customer_num 和 deep_trial_customer_num 的总和
                    this.total_try_out_num = this.list.reduce((total, item) => total + item.try_out_customer_num, 0);
                    this.total_deep_trial_num = this.list.reduce((total, item) => total + item.deep_trial_customer_num, 0);

                    // var totalTryOutNum = this.list.reduce((total, item) => total + item.try_out_customer_num, 0);
                    // var totalDeepTrialNum = this.list.reduce((total, item) => total + item.deep_trial_customer_num, 0);
                    this.$emit("change", this.searcheModel);
                }
                this.loading = false;
            });
        },
    },
};
</script>
  
<style>
/* 在这里添加样式 */
</style>
  


// WEBPACK FOOTER //
// src/views/count/table/customerRatioProgress.vue